"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnsDraggable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var noop_1 = require("../../../_util/noop");
var DraggableTable_1 = require("./DraggableTable");
function columnsDraggable(_a) {
    var _b = _a.onDragEnd, onDragEnd = _b === void 0 ? noop_1.noop : _b, _c = _a.draggableColumns, draggableColumns = _c === void 0 ? "all" : _c;
    return {
        onInjectProps: function (props) {
            return tslib_1.__assign(tslib_1.__assign({}, props), { columnsDraggable: true, draggableColumns: draggableColumns });
        },
        onInjectTable: function (render) { return function (props) {
            var table = render(props);
            var columns = props.columns;
            var newColumns = columns.filter(function (column) { return !column.ignore; });
            return (react_1.default.createElement(DraggableTable_1.DraggableTable, { table: table, draggableColumns: draggableColumns, onDragEnd: onDragEnd, columns: newColumns }));
        }; },
        onInjectBody: function (render) { return function (records, columns, topTip, bottomTip) {
            var body = render(records, columns, topTip, bottomTip);
            return (react_1.default.createElement(DraggableTable_1.DraggableTableBody, { body: body, onDragEnd: onDragEnd, draggableColumns: draggableColumns }));
        }; },
    };
}
exports.columnsDraggable = columnsDraggable;
//# sourceMappingURL=columnsDraggable.js.map